import {TheCrypt} from "../TheCrypt";
import Spine = PIXI.spine.Spine;
import {TweenLite, TimelineLite} from "gsap";
import {TheCryptGameConfig} from "../TheCryptGameConfig";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TheCryptHelper} from "../utils/TheCryptHelper";

export class TheCryptReelAnticipation extends PIXI.Container {
    private _isPlayingAnticipation: boolean;
    private _playingOnReel: boolean[];
    private _animations: Spine[];

    constructor() {
        super();
        this.name = "ReelAnticipation";
        this._isPlayingAnticipation = false;
        this._playingOnReel = ArrayHelper.initArrayWithValues(6, ()=>false);
        this.init();
    }

    private init() {
        this._animations = ArrayHelper.initArrayWithValues(6, (i: number) => {
            const animation: Spine = new Spine(TheCrypt.assetLoader.getSpineAsset("s_anticipation"));
            animation.name = "ReelAnticipation";
            animation.alpha = 0;
            animation.visible = false;
            animation.position.set(TheCryptGameConfig.reelPositions[i].x, 4);
            return animation;
        });
        this.position.set(TheCryptGameConfig.reelAreaPos.x, TheCryptGameConfig.reelAreaPos.y);
    }

    public fadeOut(reelId: number): void {
        if(!this._isPlayingAnticipation){
            return;
        }
        new TimelineLite().add(TweenLite.to(this._animations[reelId], 0.3, {alpha: 0}))
            .add(()=>{
                this._animations[reelId].visible = false;
                this.update(reelId+1)
            });
    }

    public fadeOutAnticipationSound(): void {
        if (this._isPlayingAnticipation) {
            TheCryptSoundManager.fadeSoundEffect("scatterAnticipation", 1, 0, 500);
        }
    }

    public reset(): void {
        if (this._isPlayingAnticipation) {
            TheCrypt.reelFrame.resetEyeAnimation();
            if (!TheCrypt.model.freespinTriggeredThisSpin) {
                TheCrypt.reelFrame.onAnticipationFail();
            }
            TheCryptSoundManager.stopSoundEffect(`scatterAnticipation`);
            TheCryptSoundManager.playSound(`scatterAnticipationEnd`);
            this._isPlayingAnticipation = false;
            this._playingOnReel = ArrayHelper.initArrayWithValues(6, ()=>false);
            this._animations.forEach((animation: Spine) => {
                TheCryptHelper.resetSpineItem(animation);
                animation.alpha = 0;
                animation.visible = false;
            });
        }
    }

    public update(reelId: number): void {
        if (TheCryptHelper.isFreeSpin(TheCrypt.model.mode)) {
            return;
        }

        const isNextRespin:boolean = TheCrypt.model.isNextRespin;

        if ((reelId === 6) || (TheCryptHelper.isRespin(TheCrypt.model.mode) && !TheCrypt.realArea.needFillUpReels[reelId])) {
            if(!isNextRespin){
                this.reset();
            }
            return;
        }

        if (this._animations[reelId].visible) {
            return;
        }

        if (TheCrypt.model.nearWinReels[reelId]) {
            if (!this._isPlayingAnticipation || reelId === 1) {
                TheCryptSoundManager.playSound("scatterAnticipation");
            }
            this._animations[reelId].visible = true;
            this._isPlayingAnticipation = true;
            TheCrypt.reelFrame.updateEyeAnimation(reelId);
            this.addChild(this._animations[reelId]);
            this._animations[reelId].state.setAnimation(0, "s_anticipation", true);
            new TimelineLite().add(TweenLite.to(this._animations[reelId], 0.5, {alpha: 1}));
        }
    }
}